import { VList } from 'vuetify/lib/components/VList';
import { VListItem } from 'vuetify/lib/components/VList';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c(VList,{staticClass:"soli-duration"},_vm._l((_vm.getDurations),function(duration){return _c(VListItem,{key:duration.value},[_c('SoliBtn',{staticClass:"my-1",attrs:{"block":"","outlined":"","text":duration.display,"disabled":_vm.setDisabled(duration),"icon":_vm.setIcon(duration),"color":"contrast--text"},on:{"click":function($event){return _vm.$emit('input', duration.value)}}})],1)}),1)
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }